/* eslint-disable warp-drive/no-legacy-request-patterns */
export function deleteRecordWithAuditReason(store, type, snapshot) {
  let id = snapshot.id;
  let data = {};
  let serializer = store.serializerFor(type.modelName);
  let key = serializer.payloadKeyFromModelName(type.modelName);

  serializer.serializeIntoHash(data, type, snapshot);
  // Push audit reason from serialized hash into the request's top level.
  data.reason = data[key].auditReason;
  // Remove the entity's object from request body, as we only need the audit reason.
  delete data[key];

  return this.ajax(
    this.buildURL(type.modelName, id, snapshot, 'deleteRecord'),
    'DELETE',
    { data },
  );
}

export function updateRecordWithAuditReason(store, type, snapshot) {
  let data = {};
  let serializer = store.serializerFor(type.modelName);
  let key = serializer.payloadKeyFromModelName(type.modelName);

  serializer.serializeIntoHash(data, type, snapshot);

  let id = snapshot.id;
  let url = this.buildURL(type.modelName, id, snapshot, 'updateRecord');

  // Push audit reason from serialized hash into the request's top level.
  data.reason = data[key].auditReason;
  delete data[key].auditReason;

  return this.ajax(url, 'PUT', { data });
}
